module.exports = __webpack_public_path__ + "static/media/yunying9.99acb5cc.jpg";